// Configuración de avatares disponibles para los niños
export const AVAILABLE_AVATARS = [
    {
        id: 'cerditos',
        name: 'Cerditos',
        filename: 'cerditos.png',
        path: '/avatares/cerditos.png',
        description: 'Tres cerditos adorables'
    },
    {
        id: 'ganzo',
        name: 'Ganzo',
        filename: 'ganzo.png',
        path: '/avatares/ganzo.png',
        description: 'Ganzo elegante y gracioso'
    },
    {
        id: 'liebretortuga',
        name: 'Liebre y Tortuga',
        filename: 'liebretortuga.png',
        path: '/avatares/liebretortuga.png',
        description: 'La famosa liebre y tortuga'
    },
    {
        id: 'patitofeo',
        name: 'Patito Feo',
        filename: 'patitofeo.png',
        path: '/avatares/patitofeo.png',
        description: 'El patito feo que se convierte en cisne'
    },
    {
        id: 'ratones',
        name: 'Ratones',
        filename: 'ratones.png',
        path: '/avatares/ratones.png',
        description: 'Ratones traviesos y divertidos'
    },
    {
        id: 'rey',
        name: 'Rey',
        filename: 'rey.png',
        path: '/avatares/rey.png',
        description: 'Rey majestuoso y sabio'
    },
    {
        id: 'ricitosoro',
        name: 'Ricitos de Oro',
        filename: 'ricitosoro.png',
        path: '/avatares/ricitosoro.png',
        description: 'Ricitos de Oro y los tres osos'
    },
    {
        id: 'sopadepiedra',
        name: 'Sopa de Piedra',
        filename: 'sopa de piedra.png',
        path: '/avatares/sopa de piedra.png',
        description: 'La sopa de piedra mágica'
    }
];

// Función para obtener un avatar por ID
export function getAvatarById(id: string) {
    return AVAILABLE_AVATARS.find(avatar => avatar.id === id);
}

// Función para obtener un avatar por nombre de archivo
export function getAvatarByFilename(filename: string) {
    return AVAILABLE_AVATARS.find(avatar => avatar.filename === filename);
}

// Función para obtener un avatar aleatorio
export function getRandomAvatar() {
    const randomIndex = Math.floor(Math.random() * AVAILABLE_AVATARS.length);
    return AVAILABLE_AVATARS[randomIndex];
}
